import React, { useEffect, useState } from 'react'
import ReactPlaceholder from 'react-placeholder/lib'
import Controllers from '../../Api/Controllers'
import Helpers from '../../Components/Helpers/Helpers'
import { ListPageShell, SurfaceCard, EmptyState, ActionIconButton } from '../../Components/Ui'
import parse from 'html-react-parser'
import { Link, useHistory, useParams } from 'react-router-dom'
import { FormCustom, Input } from '../../Components/Form/Form'
import NotiBlog from '../Noti/NotiBlog'

const btnPrimary = {
    borderRadius: 12,
    fontWeight: 700,
    minHeight: 42,
    padding: '0 18px',
    background: '#201030',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8
}

const HistoryNoti = ({ showFull }) => {
    const [readyCategory, setReadyCategory] = useState(false)
    const [readyNotisPopulates, setReadyNotisPopulated] = useState(false)
    const [readyNotis, setReadyNotis] = useState(false)
    const [notis, setNotis] = useState([])
    const [notisPopulated, setNotisPopulated] = useState([])
    const [categories, setCategories] = useState([])
    const [hasMore, setHasMore] = useState(true)
    const [filterText, setFilterText] = useState('')

    const { slugCategory = '', searchFilter = '', paginate = 1 } = useParams()
    const history = useHistory()

    useEffect(() => {
        setReadyNotis(false)

        Controllers.noti.get_noti({
            p_slug_category: slugCategory,
            p_filter_text: searchFilter,
            p_paginate: paginate - 1
        }).then(res => {
            setHasMore(res.data.length > 0)
            setNotis(res.data)
            setReadyNotis(true)
        })
    }, [slugCategory, searchFilter, paginate])

    useEffect(() => {
        Controllers.category.get_category_qty_noti().then(res => {
            setCategories(res.data)
            setReadyCategory(true)
        })

        Controllers.noti.get_noti_populated().then(res => {
            setNotisPopulated(res.data)
            setReadyNotisPopulated(true)
        })
    }, [])

    const handleSearchNoti = _ => {
        history.push(Helpers.config.convertUrl({ url: '/noti-historico/1/' + filterText }))
    }

    const filterLabel = searchFilter !== ''
        ? `Filtrado por: ${searchFilter}`
        : (slugCategory === '' ? undefined : `Departamento: ${slugCategory}`)

    return (
        <ListPageShell
            eyebrow="Super Papelera — Espacio de trabajo"
            title={showFull ? 'Histórico Noti Súper' : 'Tema de la Noti Súper'}
            subtitle={showFull ? (filterLabel || 'Explora noticias internas del equipo.') : 'Detalle de la noti y comentarios.'}
            badge="Noti Súper"
        >
            <div className="form-row">
                <div className="col-12 col-md-8 mb-3">
                    {showFull ? (
                        <ReactPlaceholder ready={readyNotis} showLoadingAnimation rows={20}>
                            {notis.length > 0 ? <>
                                <div style={{ padding: '8px 4px 12px' }}>
                                    {React.Children.toArray(notis.map(a => (
                                        <Link
                                            className="sp-feed-card"
                                            to={Helpers.config.convertUrl({ url: '/noti/' + a.token_noti })}
                                        >
                                            {a.file_images ? (
                                                <img
                                                    src={Helpers.config.resourcesUrl({ url: a.file_images })}
                                                    width="64"
                                                    height="64"
                                                    alt=""
                                                    style={{ borderRadius: 12, objectFit: 'cover', flexShrink: 0 }}
                                                />
                                            ) : (
                                                <span className="sp-avatar-fallback" style={{ width: 64, height: 64, display: 'inline-flex' }}>
                                                    <i className="fa fa-bell" />
                                                </span>
                                            )}
                                            <div style={{ minWidth: 0, flex: 1 }}>
                                                <h6>{a.name_noti}</h6>
                                                <div className="content_article_preview" style={{ marginBottom: 6 }}>
                                                    {parse(a.content_noti)}
                                                </div>
                                                <small className="sp-comment-meta">
                                                    <i className="fa fa-calendar-alt mr-1" />{a.date_noti}
                                                    {' · '}
                                                    <i className="fa fa-folder mr-1" />{a.name_category}
                                                    {' · '}
                                                    <i className="fa fa-comment mr-1" />{a.qty_comment_noti}
                                                </small>
                                            </div>
                                            <i className="fa fa-chevron-right align-self-center" style={{ color: '#9CA3AF' }} />
                                        </Link>
                                    )))}
                                </div>
                                {hasMore ? (
                                    <div className="d-flex justify-content-center mt-4" style={{ gap: 8 }}>
                                        <Link to={Helpers.config.convertUrl({
                                            url: slugCategory
                                                ? '/categoria/noti/' + (parseInt(paginate) - 1) + '/' + slugCategory
                                                : '/noti-historico/' + (parseInt(paginate) - 1)
                                        })}>
                                            <ActionIconButton
                                                tone={parseInt(paginate) <= 1 ? 'ghost' : 'secondary'}
                                                icon="fa fa-arrow-left"
                                                label="Atrás"
                                                disabled={parseInt(paginate) <= 1}
                                            />
                                        </Link>
                                        <Link to={Helpers.config.convertUrl({
                                            url: slugCategory
                                                ? '/categoria/noti/' + (parseInt(paginate) + 1) + '/' + slugCategory
                                                : '/noti-historico/' + (parseInt(paginate) + 1)
                                        })}>
                                            <ActionIconButton
                                                tone={notis.length < 10 ? 'ghost' : 'secondary'}
                                                icon="fa fa-arrow-right"
                                                label="Siguiente"
                                                disabled={notis.length < 10}
                                            />
                                        </Link>
                                    </div>
                                ) : null}
                            </> : (
                                <EmptyState
                                    icon="fa fa-bell"
                                    title="No se ha encontrado información"
                                    text="Prueba otro filtro o departamento."
                                />
                            )}
                        </ReactPlaceholder>
                    ) : (
                        <NotiBlog />
                    )}
                </div>
                <div className="col-12 col-md-4">
                    <SurfaceCard title="Explorar">
                        <FormCustom viewSubmit={false} onSubmit={handleSearchNoti}>
                            <Input
                                text="Buscar"
                                placeholder="Buscar noti…"
                                maxLength="255"
                                value={filterText}
                                onChange={e => setFilterText(e.currentTarget.value)}
                                append={[
                                    <button type="submit" style={{ ...btnPrimary, minHeight: 38, padding: '0 12px' }}>
                                        <i className="fa fa-search" />
                                    </button>
                                ]}
                            />
                        </FormCustom>

                        <ReactPlaceholder ready={readyCategory} showLoadingAnimation rows={10} className="mb-4 mt-4">
                            <h6 style={{ color: '#201030', fontWeight: 800, marginBottom: 12 }}>Departamentos</h6>
                            <Link
                                className="text-decoration-none"
                                style={{ color: '#FF152A', fontWeight: 600, fontSize: '0.88rem' }}
                                to={Helpers.config.convertUrl({ url: '/noti-historico' })}
                            >
                                Todas
                            </Link>
                            <hr style={{ borderColor: '#E5E7EB' }} />
                            {React.Children.toArray(categories.map(c => (
                                <p className="d-flex justify-content-between" style={{ color: '#374151', fontSize: '0.88rem' }}>
                                    <Link
                                        className="text-decoration-none"
                                        style={{ color: '#201030' }}
                                        to={Helpers.config.convertUrl({ url: '/categoria/noti/1/' + c.slug_category })}
                                    >
                                        {c.name_category}
                                    </Link>
                                    <span className="sp-comment-meta">({c.qty_notis})</span>
                                </p>
                            )))}
                        </ReactPlaceholder>

                        <h6 style={{ color: '#201030', fontWeight: 800, marginBottom: 12 }}>Noti Súper Populares</h6>
                        <ReactPlaceholder ready={readyNotisPopulates} showLoadingAnimation rows={10}>
                            {React.Children.toArray(notisPopulated.map(a => (
                                <Link
                                    className="sp-feed-card"
                                    style={{ padding: 12 }}
                                    to={Helpers.config.convertUrl({ url: '/noti/' + a.token_noti })}
                                >
                                    {a.file_images ? (
                                        <img
                                            src={Helpers.config.resourcesUrl({ url: a.file_images })}
                                            width="48"
                                            height="48"
                                            alt=""
                                            style={{ borderRadius: 10, objectFit: 'cover', flexShrink: 0 }}
                                        />
                                    ) : null}
                                    <div style={{ minWidth: 0, flex: 1 }}>
                                        <h6 style={{ fontSize: '0.86rem' }}>{a.name_noti}</h6>
                                        <small className="sp-comment-meta">
                                            {a.date_noti} · {a.qty_comment_noti} comentarios
                                        </small>
                                    </div>
                                </Link>
                            )))}
                        </ReactPlaceholder>
                    </SurfaceCard>
                </div>
            </div>
        </ListPageShell>
    )
}

HistoryNoti.defaultProps = {
    showFull: true
}

export default HistoryNoti
